import { loan_quote } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function getQuoteStatuses({ url: { service: baseURL }, token }: IAPI) {
  return async function getQuoteStatuses(): Promise<loan_quote.QuoteStatuses> {
    const url = new URL('/loan-quote/statuses/all', baseURL);

    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: token,
      },
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;

    throw new Error(
      `Error fetching ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}
